import { derived, writable } from "svelte/store"
import { overlay } from "./OverlayStore";

/**
 * Locations list from wordpress
 *
 * NOTE: Expected to be pre-sorted on server by Country, State, City, Location
 *
 * @type {Writable<*[]>}
 */
export const allLocations = writable([])


/**
 * Locations visible for the current flyout context (locations, menus, ..., etc.)
 *
 * NOTE: A location is considered visible if it has a truthy value for the location.context_url[context] prop.
 * @type {Readable<unknown>}
 */
export const contextLocations = derived([allLocations, overlay], ([$allLocations, $overlay]) => {
    // guard : nothing visible so reset
    if ( ! $overlay.visible ) return []

    // guard : context must exist
    if ( ! $overlay.context ) return []

    // guard : context.id is set
    if ( ! $overlay.context.id ) return []

    // filter locations by whether or not the relevant context url is truthy
    const locations = $allLocations
        .filter(l => l.context_urls[$overlay.context.id])

    return locations
})

